<template>
  <div class="numbers-chart" :class="{'compare': isCompareMode}">
    <div class="root">
      <div class="numbers-top">
        <div class="main-val">{{anim_mainValue}}<sup v-if="anim_mainValue != '-'">€</sup></div>
      </div>
      <div class="numbers-bottom">
        <div class="left">
          <div class="sub sub-number">{{sub1}}<sup v-if="sub1 != '-'">€</sup></div>
          <div class="sub sub-number-in-text">
            <div class="arrow" :class="{up: sub2 >= 0, down: sub2 < 0, blue: sub2 >= 0}"></div>
            <span class="text-description" v-html="sub2 +'% ' + respectOrgText"></span>
          </div>
        </div>
        <div class="right">
          <div class="sub sub-number">{{sub3}}<sup v-if="sub3 != '-'">€</sup></div>
          <div class="sub sub-number-in-text">
            <div class="arrow" :class="{up: sub4 >= 0, down: sub4 < 0, blue: sub4 >= 0}"></div>
            <span class="text-description" v-html="sub4+'% '+ t('respect_org')"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="root-compare" v-if="isCompareMode">
      <div class="numbers-top">
        <div class="main-val compare">{{anim_mainValue_compare}}<sup>€</sup></div>
      </div>
      <div class="numbers-bottom">
        <div class="left">
          <div class="sub sub-number">{{sub1_compare}}<sup>€</sup></div>
          <div class="sub sub-number-in-text">
            <div class="arrow" v-if="sub2_compare" :class="{up: sub2_compare >= 0, down: sub2_compare < 0, red: sub2_compare >= 0}"></div>
            <span class="text-description" v-html="sub2_compare +'% ' + respectOrgText"></span>
          </div>
        </div>
        <div class="right">
          <div class="sub sub-number">{{sub3_compare}}<sup>€</sup></div>
          <div class="sub sub-number-in-text">
            <div class="arrow"  v-if="sub4_compare"  :class="{up: sub4_compare >= 0, down: sub4_compare < 0, red: sub4_compare >= 0}"></div>
            <span class="text-description" v-html="sub4_compare+'% '+ t('respect_org')"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import d3 from '@/utils/d3_importer'
import gsap from 'gsap'
export default {
  name: "NumbersChart",
  props: ['data', 'filters', 'compareData'],
  // mounted () {
  //   this.drawChart()
  // },
  // updated () {
  //   this.drawChart()
  // },
  data () {
    return {
      tweened_mainValue: 0,
      tweened_sub1: 0,
      tweened_sub2: 0,
      tweened_sub3: 0,
      tweened_sub4: 0,
      tweened_mainValue_compare: 0
    }
  },
  mounted(){
    this.tweened_mainValue = Number(this.mainValue) || 0
    this.tweened_sub1 = Number(this.sub1) || 0
    this.tweened_sub2 = Number(this.sub2) || 0
    this.tweened_sub3 = Number(this.sub3) || 0
    this.tweened_sub4 = Number(this.sub4) || 0
    
    this.tweened_mainValue_compare = Number(this.mainValue_compare) || 0
  },
  computed: {
    anim_mainValue () {
      return this.tweened_mainValue.toFixed(0)
    },
    anim_mainValue_compare () {
      return this.mainValue_compare ? this.tweened_mainValue_compare.toFixed(0) : '-'
    },
    anim_sub1 () {
      return this.tweened_sub1.toFixed(0)
    },
    anim_sub2 () {
      return this.tweened_sub2
    },
    anim_sub3 () {
      return this.tweened_sub3.toFixed(0)
    },
    anim_sub4 () {
      return this.tweened_sub4
    },
    mainValue () {
      if(!this.data) return ''
      let sub = this.data.find((d)=>d.id==='avg_ticket_days')
      let val = sub ? Math.round(sub.value) : '-'
      return val
    },
    sub1 (){
      if(!this.data) return ''
      let sub = this.data.find((d)=>d.id==='avg_ticket_previous_days')
      let val = sub ? Math.round(sub.value) : '-'
      return val
    },
    sub2 (){
      if(!this.data) return ''
      let sub = this.data.find((d)=>d.id==='var_avg_ticket_days_prev')
      let val = sub ? sub.value : '-'
      return val
    },
    sub3 (){
      if(!this.data) return ''
      let sub = this.data.find((d)=>d.id==='avg_ticket_days_org')
      let val = sub ? Math.round(sub.value) : '-'
      return val
    },
    sub4 (){
      if(!this.data) return ''
      let sub = this.data.find((d)=>d.id==='var_avg_ticket_days_org')
      let val = sub ? sub.value : '-'
      return val
    },
    mainValue_compare () {
      if(!this.compareData) return ''
      let sub = this.compareData.find((d)=>d.id==='avg_ticket_days')
      let val = sub ? Math.round(sub.value) : '-'
      return val
    },
    sub1_compare (){
      if(!this.compareData) return '-'
      let sub = this.compareData.find((d)=>d.id==='avg_ticket_previous_days')
      let val = sub ? Math.round(sub.value) : '-'
      return val
    },
    sub2_compare (){
      if(!this.compareData) return '-'
      let sub = this.compareData.find((d)=>d.id==='var_avg_ticket_days_prev')
      let val = sub ? sub.value : '-'
      return val
    },
    sub3_compare (){
      if(!this.compareData) return '-'
      let sub = this.compareData.find((d)=>d.id==='avg_ticket_days_org')
      let val = sub ? Math.round(sub.value) : '-'
      return val
    },
    sub4_compare (){
      if(!this.compareData) return '-'
      let sub = this.compareData.find((d)=>d.id==='var_avg_ticket_days_org')
      let val = sub ? sub.value : '-'
      return val
    },
    respectOrgText () {
      if(this.filters.timeScale == 'DAYS30'){
        return this.t('respect_30_days')
      }
      return this.t('respect_7_days')
    }
  },
  watch: {
    mainValue: function(newValue) {
      gsap.to(this.$data, { duration: 0.3, tweened_mainValue: newValue });
    },
    sub1: function(newValue) {
      gsap.to(this.$data, { duration: 0.3, tweened_sub1: newValue });
    },
    sub2: function(newValue) {
      gsap.to(this.$data, { duration: 0.3, tweened_sub2: newValue });
    },
    sub3: function(newValue) {
      gsap.to(this.$data, { duration: 0.3, tweened_sub3: newValue });
    },
    sub4: function(newValue) {
      gsap.to(this.$data, { duration: 0.3, tweened_sub4: newValue });
    },
    mainValue_compare: function(newValue) {
      gsap.to(this.$data, { duration: 0.3, tweened_mainValue_compare: newValue });
    },
  }
}
</script>

<style scoped lang="stylus">
.numbers-chart
  // background: #fff
  position relative
  .root
    margin-bottom vw(15px)
  .root, .root-compare
    align-items: center
    display: flex
    flex-direction: column
    .desktop &
      flex-direction row
    .numbers-top
      display: flex
      margin: vw(10px)
      .desktop &
        border-right: solid 2px #555
        margin: vw(0px)
        padding 0 vw(20px)
      .main-val
        m-font-size(80, 80)
        color: $bs-blue
        font-weight: bold
        font-family: 'Anton'
        margin vw(10px)
        white-space nowrap
        &.compare
          color $compare-color
        sup
          m-font-size(60, 60)
        .desktop &
          m-font-size(86,86)
        

    .numbers-bottom
      display: flex
      flex-direction: row
      .desktop &
        align-self: stretch;
      .left,
      .right
        align-items: center
        display: flex
        flex: 0 0 50%
        flex-direction: column
        padding: vw(10px)
        text-align: center
        font-family: 'Anton'

        .sub-number
          m-font-size(36, 36)
          color: #555
          font-weight: bold
          font-family: 'Anton'
          white-space: nowrap
          sup
            m-font-size(20, 20)
        
        .sub-number-in-text
          m-font-size(12, 18)
          font-family: 'Lato'
          margin-top vh(5px)
          .desktop &
            display: flex;
            flex-direction: column;
            align-items: center;
        .arrow
          margin: 0px vw(5px)
          display: inline-block
          &.up
            border-bottom: 8px solid #555
            border-left: 7px solid transparent
            border-right: 7px solid transparent
            height: 0
            width: 0
            .desktop &
              border-bottom-width: 12px
              border-left-width: 9px
              border-right-width: 9px

          &.down
            border-left: 7px solid transparent
            border-right: 7px solid transparent
            border-top: 8px solid #555
            height: 0
            width: 0
            .desktop &
              border-left-width: 9px
              border-right-width: 9px
              border-top-width: 12px

          &.blue
            border-bottom-color: $bs-blue
            border-top-color: $bs-blue
          &.red
            border-bottom-color: $compare-color
            border-top-color: $compare-color

      .left
        border-right: solid 2px #555

  &.compare
    .root, .root-compare
      flex-direction row
      .numbers-top
        border-right none
      .numbers-bottom
        flex-direction column
        .left
          border-right none
          border-bottom: solid 2px #555
        .left, .right
          flex-direction row
          .sub-number
            margin-right vw(10px)
          .sub-number-in-text
            flex-direction row
            align-items: baseline
            .text-description
              text-align left 
</style>